import { createFileRoute } from '@tanstack/react-router'
import { NewOfferDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditOfferDialog from '@/routes/_app/-dialogs/edit-offer'

export const Route = createFileRoute('/@modal/offers/new')({
  staticData: { slotScope: '/_app' },
  pendingComponent: NewOfferDialogPending,
  component: NewOfferSlot,
})

function NewOfferSlot() {
  const slot = useModalSlot(Route)
  return <EditOfferDialog {...slot} />
}
